import axiosClient from './axiosClient';
import { Instructor } from '../types';

export const createInstructor = async (instructorData: FormData): Promise<Instructor> => {
  const response = await axiosClient.post('/instructors', instructorData);
  return response.data;
};

export const getInstructors = async (): Promise<Instructor[]> => {
  const response = await axiosClient.get('/instructors');
  return response.data;
};

export const getInstructorById = async (id: string): Promise<Instructor> => {
  const response = await axiosClient.get(`/instructors/${id}`);
  return response.data;
};

export const deleteInstructor = async (id: string): Promise<void> => {
  await axiosClient.delete(`/instructors/${id}`);
};

export const updateInstructor = async (id: string, instructorData: FormData): Promise<Instructor> => {
  const response = await axiosClient.patch(`/instructors/${id}`, instructorData);
  return response.data;
};
